import { createContext } from 'react'
import type { Mode } from './types/Mode'

export interface ModeContextValue {
  mode: Mode
  setMode: (mode: Mode) => void
}

export const ModeContext = createContext<ModeContextValue | undefined>(undefined)
